<template>
  <div class="strategy-page">
    <el-card shadow="never" class="filter-card">
      <el-form :inline="true" class="filter-form">
        <el-form-item label="项目">
          <el-select v-model="query.projectId" clearable filterable placeholder="全部项目" @change="onQueryProject">
            <el-option v-for="item in projects" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="合同游戏">
          <el-select v-model="query.tagId" clearable filterable placeholder="全部合同游戏" @change="onQueryTag">
            <el-option v-for="item in queryTags" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="子游戏">
          <el-select v-model="query.appkey" clearable filterable placeholder="全部子游戏">
            <el-option v-for="item in queryApps" :key="item.appkey" :label="appLabel(item)" :value="item.appkey" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" clearable placeholder="全部状态">
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item class="filter-actions">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never" class="table-card">
      <div class="table-actions">
        <el-button type="primary" icon="el-icon-plus" @click="openCreate">新增策略</el-button>
      </div>
      <el-table :data="rows" v-loading="loading" border>
        <el-table-column prop="project_name" label="项目" min-width="130" />
        <el-table-column prop="tag_name" label="合同游戏" min-width="140" />
        <el-table-column prop="app_name" label="子游戏" min-width="160" />
        <el-table-column prop="appkey" label="appkey" width="110" />
        <el-table-column prop="package_adjustment" label="切包调整" min-width="180" show-overflow-tooltip />
        <el-table-column prop="package_condition" label="切包条件" min-width="180" show-overflow-tooltip />
        <el-table-column prop="package_process" label="切包流程" min-width="220" show-overflow-tooltip />
        <el-table-column prop="package_remark" label="切包备注" min-width="170" show-overflow-tooltip />
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-switch :value="scope.row.status" :active-value="1" :inactive-value="0" @change="value => toggleStatus(scope.row, value)" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="145" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" icon="el-icon-delete" class="danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next"
        :total="total"
        :page-size="query.size"
        :current-page.sync="query.page"
        @current-change="loadList"
      />
    </el-card>

    <el-dialog :title="form.id ? '编辑切包策略' : '新增切包策略'" :visible.sync="dialogVisible" width="760px" :close-on-click-modal="false">
      <el-form ref="strategyForm" :model="form" :rules="rules" label-width="104px">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="8">
            <el-form-item label="项目" prop="project_id">
              <el-select v-model="form.project_id" filterable placeholder="请选择" @change="onFormProject">
                <el-option v-for="item in projects" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="合同游戏" prop="tag_id">
              <el-select v-model="form.tag_id" filterable placeholder="请选择" @change="onFormTag">
                <el-option v-for="item in formTags" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="子游戏" prop="appkey">
              <el-select v-model="form.appkey" filterable placeholder="请选择">
                <el-option v-for="item in formApps" :key="item.appkey" :label="appLabel(item)" :value="item.appkey" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="切包调整" prop="package_adjustment">
          <el-input v-model="form.package_adjustment" type="textarea" :rows="3" maxlength="2000" show-word-limit />
        </el-form-item>
        <el-form-item label="切包条件">
          <el-input v-model="form.package_condition" type="textarea" :rows="3" maxlength="2000" show-word-limit />
        </el-form-item>
        <el-form-item label="切包流程" prop="package_process">
          <el-input v-model="form.package_process" type="textarea" :rows="4" maxlength="5000" show-word-limit />
        </el-form-item>
        <el-form-item label="切包备注">
          <el-input v-model="form.package_remark" type="textarea" :rows="3" maxlength="5000" show-word-limit />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="停用" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPackageSwitchOptions,
  getPackageSwitchStrategies,
  savePackageSwitchStrategy,
  deletePackageSwitchStrategy,
} from '@/api/packageSwitchStrategy';

const emptyForm = () => ({
  id: null,
  project_id: null,
  tag_id: null,
  appkey: null,
  package_adjustment: '',
  package_condition: '',
  package_process: '',
  package_remark: '',
  status: 1,
});

export default {
  name: 'packageSwitchStrategy',
  data() {
    return {
      loading: false,
      saving: false,
      dialogVisible: false,
      projects: [],
      tags: [],
      apps: [],
      rows: [],
      total: 0,
      query: { page: 1, size: 20, projectId: null, tagId: null, appkey: null, status: null },
      form: emptyForm(),
      rules: {
        project_id: [{ required: true, message: '请选择项目', trigger: 'change' }],
        tag_id: [{ required: true, message: '请选择合同游戏', trigger: 'change' }],
        appkey: [{ required: true, message: '请选择子游戏', trigger: 'change' }],
        package_adjustment: [{ required: true, message: '请输入切包调整', trigger: 'blur' }],
      },
    };
  },
  computed: {
    queryTags() {
      return this.tags.filter(item => !this.query.projectId || item.project_id === this.query.projectId);
    },
    queryApps() {
      return this.apps.filter(item => (!this.query.tagId || item.tag_id === this.query.tagId)
        && (!this.query.projectId || this.tagBelongsToProject(item.tag_id, this.query.projectId)));
    },
    formTags() {
      return this.tags.filter(item => item.project_id === this.form.project_id);
    },
    formApps() {
      return this.apps.filter(item => item.tag_id === this.form.tag_id);
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.loadOptions();
      await this.loadList();
    },
    async loadOptions() {
      const response = await getPackageSwitchOptions({});
      const data = response.data.data || {};
      this.projects = data.projects || [];
      this.tags = data.tags || [];
      this.apps = data.apps || [];
    },
    async loadList() {
      this.loading = true;
      try {
        const response = await getPackageSwitchStrategies(this.query);
        const data = response.data.data || {};
        this.rows = data.records || [];
        this.total = Number(data.total || 0);
      } finally {
        this.loading = false;
      }
    },
    search() {
      this.query.page = 1;
      this.loadList();
    },
    resetQuery() {
      this.query = { page: 1, size: 20, projectId: null, tagId: null, appkey: null, status: null };
      this.loadList();
    },
    onQueryProject() {
      this.query.tagId = null;
      this.query.appkey = null;
    },
    onQueryTag() {
      this.query.appkey = null;
    },
    onFormProject() {
      this.form.tag_id = null;
      this.form.appkey = null;
    },
    onFormTag() {
      this.form.appkey = null;
    },
    tagBelongsToProject(tagId, projectId) {
      const tag = this.tags.find(item => item.id === tagId);
      return tag && tag.project_id === projectId;
    },
    appLabel(item) {
      return `${item.name} (${item.appkey})`;
    },
    openCreate() {
      this.form = emptyForm();
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.strategyForm && this.$refs.strategyForm.clearValidate());
    },
    openEdit(row) {
      this.form = {
        id: row.id,
        project_id: row.project_id,
        tag_id: row.tag_id,
        appkey: row.appkey,
        package_adjustment: row.package_adjustment,
        package_condition: row.package_condition || '',
        package_process: row.package_process,
        package_remark: row.package_remark || '',
        status: row.status,
      };
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.strategyForm && this.$refs.strategyForm.clearValidate());
    },
    submit() {
      this.$refs.strategyForm.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        try {
          await savePackageSwitchStrategy(this.form);
          this.$message.success('保存成功');
          this.dialogVisible = false;
          await this.loadList();
        } finally {
          this.saving = false;
        }
      });
    },
    async toggleStatus(row, status) {
      const payload = {
        id: row.id,
        project_id: row.project_id,
        tag_id: row.tag_id,
        appkey: row.appkey,
        package_adjustment: row.package_adjustment,
        package_condition: row.package_condition || '',
        package_process: row.package_process,
        package_remark: row.package_remark || '',
        status,
      };
      try {
        await savePackageSwitchStrategy(payload);
        row.status = status;
        this.$message.success(status === 1 ? '已启用' : '已停用');
      } catch (error) {
        this.$message.error('状态更新失败');
      }
    },
    remove(row) {
      this.$confirm(`确认删除“${row.app_name}”的切包策略吗？`, '删除确认', { type: 'warning' })
        .then(async () => {
          await deletePackageSwitchStrategy(row.id);
          this.$message.success('删除成功');
          if (this.rows.length === 1 && this.query.page > 1) this.query.page -= 1;
          this.loadList();
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.strategy-page {
  min-height: calc(100vh - 70px);
  padding: 22px;
  background:
    radial-gradient(circle at 82% 8%, rgba(195, 221, 205, .72), transparent 30%),
    linear-gradient(145deg, #f3f6ef, #edf2f4 62%, #e8eee9);
}
.filter-card { margin-bottom: 16px; border: 0; }
.filter-form { display: flex; flex-wrap: wrap; align-items: flex-end; }
.filter-actions { margin-left: auto; }
.table-card { border: 0; }
.table-actions { margin-bottom: 14px; text-align: right; }
.pager { margin-top: 18px; text-align: right; }
.danger { color: #c54e43; }
.el-select { width: 100%; }
@media (max-width: 768px) {
  .strategy-page { padding: 12px; }
  .filter-form { display: block; }
  .filter-actions { margin-left: 0; }
}
</style>
